import { Note } from '../generated/interfaces';
import { ResolveData, Resolve } from '@angular/router';

export interface NoteResolveData {
    notes: Note[]
    users: { [id: number]: string }
    currentUser: {
        id: number;
        name: string;
    }
}

export function createNoteResolve(noteResolver: new (...args: any[]) => Resolve<NoteResolveData>): ResolveData {
    return {
        data: noteResolver
    };
}
